/**
 * DailyCheckGate — full-screen blocker shown when the company requires
 * daily vehicle checks and the user hasn't completed one today.
 */
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShieldCheck, ClipboardCheck } from "lucide-react";

interface DailyCheckGateProps {
  onCheckCompleted?: () => void;
}

export function DailyCheckGate({ onCheckCompleted }: DailyCheckGateProps) {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
      <Card className="max-w-sm w-full">
        <CardContent className="pt-8 pb-6 text-center space-y-5">
          <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
            <ShieldCheck className="w-8 h-8 text-primary" />
          </div>
          
          <div className="space-y-2">
            <h2 className="text-xl font-bold">Daily Vehicle Check</h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Please complete today's vehicle check before accessing your jobs.
            </p>
          </div>

          <p className="text-xs text-muted-foreground">
            This resets at midnight each day.
          </p>

          <Button
            size="lg"
            className="w-full gap-2"
            onClick={() => navigate("/vehicle-daily-checks")}
          >
            <ClipboardCheck className="w-5 h-5" />
            Start Vehicle Check
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
